import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import AuthService from '../service/AuthService';
import loginImg from '../assets/login-vector.avif';
import '@fortawesome/fontawesome-free/css/all.min.css';

const SignUpPage = () => {
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isAggreed, seIsAggreed] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!/^[0-9]{10,15}$/.test(phone)) {
            Swal.fire({
                icon: "error",
                title: "Invalid phone number",
                text: "Phone number should be 10-15 digits.",
                confirmButtonColor: '#c70000'
            });
            return;
        }

        if (password !== confirmPassword) {
            Swal.fire({
                icon: "error",
                title: "Passwords do not match",
                text: "Please make sure both passwords are the same.",
                confirmButtonColor: '#c70000'
            });
            return;
        }

        setLoading(true);
        try {
            await AuthService.register(name, address, phone, email, password);
            Swal.fire({
                icon: "success",
                title: "Account created!",
                text: "Please log in with your phone number and password.",
                confirmButtonColor: '#c70000'
            });
            navigate('/login');
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Sign up failed",
                text: error.message || "Failed to create account.",
                confirmButtonColor: '#c70000'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className='login_page'>
            <div className="container">
                <div className='row d-flex justify-content-around align-items-center'>

                    <div className='col-md-6 d-md-block d-none'>
                        <img src={loginImg} className='img-fluid' alt='Sign Up' loading="lazy" />
                    </div>

                    <div className='col-md-5'>
                        <div className="card login_panel">
                            <div className="card-body">
                                <h3 className="card-title mb-0 text-md-start text-center">
                                    Sign Up
                                </h3>
                                <p className='mb-4 mb-md-4 text-md-start text-center'>Create your account to get started.</p>
                                <form onSubmit={isAggreed && handleSubmit}>
                                    <div className="form-group text-left">
                                        <input
                                            type="text"
                                            id="name"
                                            placeholder="Company Name"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="form-group text-left">
                                        <input
                                            type="text"
                                            id="address"
                                            placeholder="Address"
                                            className="form-control"
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="form-group text-left">
                                        <input
                                            type="tel"
                                            id="phone"
                                            placeholder="Phone No."
                                            className="form-control"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="form-group text-left">
                                        <input
                                            type="email"
                                            id="email"
                                            placeholder="Email"
                                            className="form-control"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="form-group text-left">
                                        <div className="input-group">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                id="password"
                                                placeholder="Password"
                                                className="form-control"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                minLength={6}
                                                required
                                            />
                                            <span
                                                className="input-group-text password-toggle"
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="form-group mb-4 text-left">
                                        <div className="input-group">
                                            <input
                                                type={showConfirmPassword ? "text" : "password"}
                                                id="confirmPassword"
                                                placeholder="Confirm Password"
                                                className="form-control"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                required
                                            />
                                            <span
                                                className="input-group-text password-toggle"
                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            >
                                                <i className={`fa-solid ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="form-check text-left mb-2 mb-md-4 mt-2">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="isAgrred"
                                            checked={isAggreed}
                                            onChange={(e) => seIsAggreed(e.target.checked)}
                                        />
                                        <label className="form-check-label small" htmlFor="isAgrred">
                                            I agree to receive SMS messages from Breakdown Inc. for account verification, login authentication, password resets, and security alerts. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for help. See our <Link to="/privacypolicy">Privacy Policy</Link> and <Link to="/termsandcondition">Terms and Conditions</Link>.
                                        </label>
                                    </div>

                                    <button type="submit" className="btn btn-primary w-100 btn-theme" disabled={loading || !isAggreed}>
                                        {loading ? (
                                            <span>
                                                <i className="fas fa-spinner fa-spin"></i> Please wait...
                                            </span>
                                        ) : (
                                            <span>
                                                Sign Up
                                            </span>
                                        )}
                                    </button>

                                    <p className="mt-3 mb-0 text-center small">
                                        Already have an account? <Link to="/login">Log In</Link>
                                    </p>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </section>
    );
};

export default SignUpPage;
